import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useLocalizedContent } from "@/hooks/use-localized-content";

const Section = ({ title, body }: { title: string; body: string }) => (
  <section>
    <h2 className="font-display text-xl font-semibold mb-3">{title}</h2>
    <div className="text-muted-foreground leading-relaxed whitespace-pre-line">{body}</div>
  </section>
);

const PrivacyPolicy = () => {
  const { c } = useLocalizedContent();
  const sections = Array.from({ length: 10 }, (_, i) => ({
    title: c(`privacy_s${i + 1}_title`, "_none_"),
    body: c(`privacy_s${i + 1}_body`, "_none_"),
  }));

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-6 py-16 max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-primary hover:underline mb-8">
          <ArrowLeft size={16} /> {c("privacy_back", "_none_", "Voltar ao site")}
        </Link>

        <h1 className="font-display text-4xl font-bold mb-2 text-foreground">
          {c("privacy_title", "_none_", "Política de Privacidade")}
        </h1>
        <p className="text-muted-foreground mb-10 text-sm">
          {c("privacy_update", "_none_", "Última atualização: março de 2026")}
        </p>

        <div className="prose prose-sm max-w-none text-foreground space-y-6">
          {sections.map((s, i) => (
            <Section key={i} title={s.title} body={s.body} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
